import { User, ExternalLink, UserCheck } from 'lucide-react';
import { RSVPOut } from '@/lib/api';

interface ConfirmedListProps {
  rsvps: RSVPOut[];
}

export function ConfirmedList({ rsvps }: ConfirmedListProps) {
  const handleProfileClick = (userId: string) => {
    window.open(`/profile/${userId}`, '_blank');
  };

  if (rsvps.length === 0) {
    return (
      <div className="text-center py-8">
        <User size={48} className="text-adv-mediumGray mx-auto mb-4" />
        <p className="text-adv-lightGray">No confirmed attendees yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 text-adv-lightGray text-sm pb-1 border-b border-adv-mediumGray/30">
        <UserCheck size={14} />
        <span>Confirmed Riders</span>
      </div>
      {rsvps.map((rsvp) => (
        <div
          key={rsvp.id}
          className="flex items-center p-3 border border-adv-mediumGray rounded-lg hover:border-adv-orange transition-colors cursor-pointer group"
          onClick={() => handleProfileClick(rsvp.user.id)}
        >
          <div className="h-10 w-10 rounded-full bg-adv-darkGray flex items-center justify-center mr-3">
            {rsvp.user.avatar_url ? (
              <img
                src={rsvp.user.avatar_url}
                alt={rsvp.user.username}
                className="h-full w-full rounded-full object-cover"
              />
            ) : (
              <User size={20} className="text-adv-lightGray" />
            )}
          </div>
          <div className="flex-1">
            <p className="font-medium text-white group-hover:text-adv-orange transition-colors">
              {rsvp.user.first_name} {rsvp.user.last_name}
            </p>
            <p className="text-sm text-adv-lightGray">
              @{rsvp.user.username}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-xs text-adv-lightGray">
              {new Date(rsvp.created_at).toLocaleDateString()}
            </div>
            <ExternalLink size={14} className="text-adv-lightGray group-hover:text-adv-orange transition-colors" />
          </div>
        </div>
      ))}
    </div>
  );
}
